import { createStateSelectorHook } from 'src/lib/sweetState';
import { EMAIL_CSV_RESOURCES } from 'src/data/performance';
import { PerformanceStore, isDisconnectedStatus, useCurrentWorkspace } from 'src/store';

const usePerformanceState = createStateSelectorHook(PerformanceStore, ['accounts']);

export const useResourcesCSVDocumentsAccounts = (shouldGetAllAccounts) => {
  const { accounts } = usePerformanceState();
  const currentWorkspace = useCurrentWorkspace();

  const alignedAccounts = shouldGetAllAccounts ? accounts : currentWorkspace?.accounts;

  if (!alignedAccounts) {
    return [];
  }

  return EMAIL_CSV_RESOURCES.reduce((acc, resource) => {
    const filteredAccounts = (alignedAccounts[resource] || []).filter(
      (account) => !isDisconnectedStatus(account.status)
    );
    return [...acc, ...filteredAccounts];
  }, []);
};
